import { getPageNodes } from 'ha/helpers/graphql';
import { Actions } from '../constants';

const query = `
  query {
    searchCategories
    citiesFeatured {
      edges {
        node {
          cityUrl
          city
          cityLocalized
          countryLocalized
          searchUrl
          country
          countryCode
        }
      }
    }
  }
`;

function loadStart(payload) {
  return {
    type: Actions.LOAD_START,
    payload,
  };
}

function loadDone(payload) {
  return {
    type: Actions.LOAD_DONE,
    payload,
  };
}

function loadFail(payload) {
  return {
    type: Actions.LOAD_FAIL,
    payload,
  };
}

// eslint-disable-next-line import/prefer-default-export
export const load = () => (dispatch, getState, services) => {
  dispatch(loadStart());

  return services
    .graphql(query)
    .then(({ data: { citiesFeatured, searchCategories } }) => {
      dispatch(
        loadDone({
          citiesFeatured: getPageNodes(citiesFeatured),
          searchCategories,
        }),
      );
    })
    .catch(errors => {
      dispatch(loadFail(errors));
    });
};
